import { render, staticRenderFns } from "./mainTable.vue?vue&type=template&id=0d059012"
import script from "./mainTable.vue?vue&type=script&lang=js"
export * from "./mainTable.vue?vue&type=script&lang=js"
import style0 from "./mainTable.vue?vue&type=style&index=0&id=0d059012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports